/* eslint-disable max-lines-per-function */
import { Routes, Route } from 'react-router-dom';
import { WithFeatureFlags } from '@/features/featureFlags/WithFeatureFlags';
import {
  DetailsPage,
  OverviewPage,
} from '@/domain/mitarbeiter/pages/rotationsplan';
import { Anlageassistent } from '@/domain/mitarbeiter/pages/anlageassistent';
import { DefaultPage } from '@/pages/DefaultPage';
import { CreateRotationsplan } from '@/domain/mitarbeiter/features/rotationsplan/features/CreateRotationsplan/CreateRotationsplan';
import { WithLocationGuard } from '@/features/locationGuard/WithLocationGuard';
import { buildLink } from '@/utils';
import { CreateStation } from '@/domain/mitarbeiter/features/rotationsplan/features/CreateStation/CreateStation';
import { Suspense } from 'react';

export function Mitarbeiter() {
  return (
    <Routes>
      <Route
        path="/rotationsplaene"
        element={
          <MitarbeiterRoutesWrapper>
            <WithFeatureFlags name="rotationsplan">
              <OverviewPage />
            </WithFeatureFlags>
          </MitarbeiterRoutesWrapper>
        }></Route>

      <Route
        path="/rotationsplaene/:view"
        element={
          <MitarbeiterRoutesWrapper>
            <WithFeatureFlags name="rotationsplan">
              <OverviewPage />
            </WithFeatureFlags>
          </MitarbeiterRoutesWrapper>
        }>
        <Route path="create" element={<CreateRotationsplan />} />
      </Route>
      <Route
        path="/rotationsplan/:id"
        element={
          <MitarbeiterRoutesWrapper>
            <WithFeatureFlags name="rotationsplan">
              <DetailsPage />
            </WithFeatureFlags>
          </MitarbeiterRoutesWrapper>
        }>
        <Route
          path=":abschnittId/station/create"
          element={
            <Suspense fallback={<></>}>
              <CreateStation />
            </Suspense>
          }
        />
      </Route>
      <Route
        path="/create/*"
        element={
          <MitarbeiterRoutesWrapper hideNavigation>
            <WithLocationGuard
              countries={['DE']}
              fallbackURL={buildLink('mitarbeiterListe')}>
              <WithFeatureFlags name="mitarbeiteranlage">
                <Anlageassistent />
              </WithFeatureFlags>
            </WithLocationGuard>
          </MitarbeiterRoutesWrapper>
        }
      />
    </Routes>
  );
}

export function MitarbeiterRoutesWrapper({
  hideNavigation = false,
  children,
}: {
  hideNavigation?: boolean;
  children: React.ReactNode;
}) {
  if (hideNavigation) {
    return <>{children}</>;
  }
  return <DefaultPage>{children}</DefaultPage>;
}
